import "./Home.module.css";
import MainHeader from "@/reusable_sections/Header";
import LArtDeVivreEnUzege from "./sections/LArtDeVivreEnUzege";
import QuantifiableImpact from "./sections/QuantifiableImpact";
import SurvivalEssentials from "./sections/SurvivalEssentials";
import CreativeTeam from "./sections/CreativeTeam";
import TheAjmTrustGuarantee from "./sections/TheAjmTrustGuarantee";
import ReadyForADataBackedStrategy from "./sections/ReadyForADataBackedStrategy";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainHeader />
      <LArtDeVivreEnUzege />
      <QuantifiableImpact />
      <SurvivalEssentials />
      <CreativeTeam />
      <TheAjmTrustGuarantee />
      <ReadyForADataBackedStrategy />
      <Footer />
    </div>;
}